import { useEffect, useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import ProblemSolution from "@/components/sections/ProblemSolution";
import HowItWorks from "@/components/sections/HowItWorks";
import SkillToIncome from "@/components/sections/SkillToIncome";
import WhoFor from "@/components/sections/WhoFor";
import Offer from "@/components/sections/Offer";
import Instructor from "@/components/sections/Instructor";
import FAQ from "@/components/sections/FAQ";
import LeadCapture from "@/components/sections/LeadCapture";
import ForOrganizations from "@/components/sections/ForOrganizations";
import WorkforceBridge from "@/components/sections/WorkforceBridge";
import FinalCTA from "@/components/sections/FinalCTA";
import RegistrationForm from "@/components/sections/RegistrationForm";
import SubscribeModal from "@/components/sections/SubscribeModal";
import FeaturedBuilds from "@/components/sections/FeaturedBuilds";
import { getPublicConfig } from "@/lib/api";
import { track, installCtaListener } from "@/lib/tracker";
import { captureReferrerFromUrl } from "@/lib/referrer";

export default function Landing() {
  // Start as null — Countdown.jsx safely handles a null/invalid target
  // (renders 00s until /api/config resolves) instead of using a stale
  // hard-coded past date that would freeze the timer.
  const [courseDate, setCourseDate] = useState(null);

  useEffect(() => {
    const ref = captureReferrerFromUrl();
    track("page_view", { page: "landing", ref: ref || undefined });
    installCtaListener();
    getPublicConfig()
      .then((cfg) => cfg?.course_date && setCourseDate(cfg.course_date))
      .catch(() => {});
  }, []);

  return (
    <div data-testid="landing-page" className="bg-white min-h-screen text-ink">
      <Header />
      <main>
        <Hero />
        <ProblemSolution />
        <HowItWorks />
        <FeaturedBuilds />
        <SkillToIncome />
        <WhoFor />
        <Offer courseDate={courseDate} />
        <Instructor />
        <LeadCapture />
        <WorkforceBridge />
        <ForOrganizations />
        <FAQ />
        <FinalCTA>
          <RegistrationForm />
        </FinalCTA>
      </main>
      <Footer />
      <SubscribeModal />
    </div>
  );
}
